const millisecondNow = getBestAvailableMillisecondTimer();
export class NanosecondTimer {
    constructor(millisecondStart) {
        this.millisecondStart = millisecondStart;
    }
    duration() {
        return Math.round((millisecondNow() - this.millisecondStart) * 1e6);
    }
    static start() {
        return new NanosecondTimer(millisecondNow());
    }
}
function getBestAvailableMillisecondTimer() {
    if (typeof performance === 'object' && typeof performance.now === 'function')
        return () => performance.now();
    return () => Date.now();
}
//# sourceMappingURL=metrics.js.map